"use strict";exports.upperCaseFirst=function(e){return e.charAt(0).toUpperCase()+e.slice(1)};
//# sourceMappingURL=upperCaseFirst.cjs.map
